<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />

    <div v-else-if="data.course.id" class="mt-8 mb-16">
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div class="max-w-full flex justify-center">
          <img
            :src="data.course.image"
            alt=""
            class="max-w-full object-cover shadow-lg rounded-lg md:max-w-lg lg:max-w-sm"
          />
        </div>
        <div
          class="text-lg leading-6 font-medium space-y-2 px-0 text-center md:px-8 lg:px-0 lg:text-left"
        >
          <h2 class="text-2xl font-bold">{{ data.course.name }}</h2>

          <div class="text-indigo-600">
            Автор:
            <router-link
              :to="{ name: 'user_show', params: { id: data.user.id } }"
              >{{ data.user.name }}</router-link
            >
          </div>
          <div class="text-lg">
            <h3>Описание Курса</h3>
            <p v-html="data.course.description" class="text-gray-500"></p>
          </div>
          <div>
            <router-link
              :to="{
                name: 'adminCourse_chapters',
                params: { course_id: data.course.id },
              }"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >Перейти к списку Глав</router-link
            >
          </div>
        </div>
      </div>

      <!-- <div class="col-12 col-md-6 mb-5">
        <h2 class="d-block mb-3">{{ data.course.name }}</h2>
        <strong class="mb-3">Описание Курса:</strong>
        <p v-html="data.course.description" class=""></p>
        <p>
          <strong>Автор: </strong>
          <router-link
            :to="{ name: 'user_show', params: { id: data.user.id } }"
            >{{ data.user.name }}</router-link
          >
        </p>
      </div>
      <div
        class="col-12 col-md-6 mb-5 text-center d-flex flex-column align-items-center"
      >
        <img :src="data.course.image" alt="" class="w-75 d-block mx-auto" />

        <router-link
          :to="{
            name: 'adminCourse_chapters',
            params: { course_id: data.course.id },
          }"
          class="btn btn-primary w-75 mt-3"
          >Перейти к списку Глав</router-link
        >
      </div> -->
    </div>

    <!-- 
        <div v-else-if="data.course.id">
            <h2>{{data.course.name}}</h2>
            <img :src="data.course.image" alt="" class="w-50 d-block mx-auto">
            <h3>Автор: <router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.name }}</router-link></h3>
            <router-link  :to="{ name: 'adminCourse_chapters', params: { course_id: data.course.id } }">Перейти к списку Глав</router-link>
            <p></p>
            <p></p>
            <p>Описание Курса:</p>
            <p v-html="data.course.description" class="bg-light shadow p-3 mb-5 bg-white rounded"></p>
            <hr>
        </div>
 -->
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import ErrorMessage from "@/components/ErrorMessage";

export default {
  components: {
    Loader,
    PageTitle,
    ErrorMessage,
    BreadCrumbs,
  },
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "" },
      title: "Просмотр Курса",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/courses/" + this.$route.params.id
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },
};
</script>